import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { msalConfig } from './authConfig';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Initialize MSAL and then render the app
msalInstance.initialize().then(() => {
  // Handle redirect promise
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        const account = response.account;
        msalInstance.setActiveAccount(account);
      }
    })
    .catch((error) => {
      console.error('Redirect error:', error);
    });

  // Set active account if already logged in
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Listen for login events
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as any;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  // Render the app after MSAL is initialized
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
});
